import { render, staticRenderFns } from "./fitvipDw.vue?vue&type=template&id=9fcfdf6a&scoped=true&"
import script from "./fitvipDw.vue?vue&type=script&lang=ts&"
export * from "./fitvipDw.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcfdf6a",
  null
  
)

export default component.exports